/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemHealthRiskSchema = z.object({
  key: z
    .enum([
      'PLANNED_START_DATE_PASSED',
      'PLANNED_FINISH_DATE_PASSED',
      'UNPLANNED_WORK',
      'DELTA_DIFF_LARGER_THAN_FIVE_PERCENT',
      'DELTA_DIFF_LARGER_THAN_ONE_PERCENT',
    ])
    .describe('Risk key'),
});
